<template>
    <div id="demo-basic-card">
        <vx-card class="mb-base">
            <template   slot="actions">
                <vx-tooltip text="Add new module" position="left">
                    <feather-icon @click="redirectToAddModule()" icon="EditIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                </vx-tooltip>
            </template>

            <div id="allModulesLoadingDiv" class="vs-con-loading__container">
                <div class="vx-row">
                    <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-if="modulesData.length" v-for="(listItem, index) in modulesData" :key="index">
                        <vx-card>
                            <div slot="no-body">
                                <img :src="listItem.image" alt="content-img" class="responsive card-img-top">
                            </div>
                            <h5 class="mb-2">{{ listItem.name }}</h5>
                            <p class="text-grey">{{ listItem.hours }} Minutes</p>
                            <p class="text-grey">{{ getLessionNumber(listItem) }}</p>
                            <div class="flex justify-between flex-wrap">
                                <vs-button @click="viewModule(listItem)"class="mt-4 mr-2 shadow-lg" type="gradient" color="primary"  icon-pack="feather" icon="icon-menu" icon-after>View</vs-button>
                                <vs-button @click="editModule(listItem)"class="mt-4 mr-2 shadow-lg" type="gradient" color="danger"  icon-pack="feather" icon="icon-edit" icon-after>Edit</vs-button>
                            </div>
                        </vx-card>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleModuleManagement from '@/store/module-management/moduleModuleManagement.js'

export default{
    data() {
        return {
            modulesData: [],
        }
    },
    components: {
        VuePerfectScrollbar,
    },
    methods: {
        redirectToAddModule() {
            this.$router.push("/modules/add").catch(() => {})
        },
        getLessionNumber(moduleData) {
            if(moduleData.lession_number && moduleData.lession_number.length){
                return 'Lession number - '+moduleData.lession_number.join(', ');
            }
            else return ""
        },
        getAllModules() {
            // this.$vs.loading({
            //     container: '#allModulesLoadingDiv',
            //     scale: 0.6
            // })

            this.$store.dispatch("moduleManagement/getAllModules")
                .then(res => { 
                    this.modulesData = res.data
                    // this.$vs.loading.close('#allModulesLoadingDiv > .con-vs-loading')
                })
                .catch(err => { 
                    // this.$vs.loading.close('#allModulesLoadingDiv > .con-vs-loading')
                })
        },
        viewModule(module) {
            this.$router.push("/modules/view/" + module.id).catch(() => {})
        },
        editModule(module) {
            this.$router.push("/modules/edit/" + module.id).catch(() => {})
        },
    },
    created() {
        if(!moduleModuleManagement.isRegistered) {
            this.$store.registerModule('moduleManagement', moduleModuleManagement)
            moduleModuleManagement.isRegistered = true
        }

        this.modulesData = this.$store.state.moduleManagement.modules
        this.getAllModules()
    },

}
</script>

